import {
  GetAddressBookListDTO,
  AddressBookModel,
  AutoSweepAddressBookListModel,
  AutoSweepRuleModel,
  AutoSweepRuleDetailModel,
  UpdateAddressBookDTO,
  AddAddressBookDTO,
  delAddressBookDTO,
  AddWhiteListSign,
} from './model'
import PolicyBaseApi from './base'
import { DEFAULT_PAGE_SIZE } from '@/constants'
import { PolicyItemModel } from '@/constants/enum'

class PolicyApi extends PolicyBaseApi {
  async getAddressBookList(dto: GetAddressBookListDTO) {
    return this.post<AddressBookModel[]>('/addressbook/query', dto)
  }
  async getAddressBookCount(dto: GetAddressBookListDTO) {
    return this.post<number>('/addressbook/count', dto)
  }
  async getAutoSweepAddressBookList(dto: GetAddressBookListDTO) {
    return this.post<AutoSweepAddressBookListModel>('/addressbook/queryAutoSweepAddressBookList', {
      pageSize: DEFAULT_PAGE_SIZE,
      ...dto,
    })
  }
  async getAutoSweepRuleList() {
    return this.post<AutoSweepRuleModel[] | null>('/autoSweepRule/list')
  }
  async getAutoSweepRuleDetail(modifyKey: string) {
    return this.post<AutoSweepRuleDetailModel>('/autoSweepRule/getAutoSweepDetail', {
      modifyKey,
    })
  }
  async updateAddressBook(dto: UpdateAddressBookDTO) {
    return this.post<boolean>('/addressbook/update', dto)
  }
  async addAddressBook(dto: AddAddressBookDTO) {
    return this.post<string>('/addressbook/add', dto)
  }
  async addWhiteListSign(dto: AddWhiteListSign) {
    return this.post<string>('/addressbook/addWhiteListSign', dto)
  }
  async delAddressBook(dto: delAddressBookDTO) {
    return this.post<boolean>('/addressbook/del', dto)
  }
  async queryTxRulesByAddressBookKey(dto: { addressBookKey: string }) {
    return this.post<PolicyItemModel[]>('/addressbook/queryTxRulesByAddressBookKey', dto)
  }
  async queryAutoSweepRulesByAddressBookKey(dto: { addressBookKey: string }) {
    return this.post<AutoSweepRuleModel[]>('/addressbook/queryAutoSweepRulesByAddressBookKey', dto)
  }
  async existsPhishingAddress(dto: { address: string }) {
    return this.post<boolean>('/addressbook/existsPhishingAddress', dto)
  }
}

export default new PolicyApi()
